import { render, staticRenderFns } from "./Persona_agregar.vue?vue&type=template&id=495d8af1&scoped=true"
import script from "./Persona_agregar.vue?vue&type=script&lang=js"
export * from "./Persona_agregar.vue?vue&type=script&lang=js"
import style0 from "./Persona_agregar.vue?vue&type=style&index=0&id=495d8af1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d8af1",
  null
  
)

export default component.exports